// extracted by mini-css-extract-plugin
export var component = "SiteSearch-module--component--GT7ft";
export var form = "SiteSearch-module--form--zYY+b";